(function () {
  function buildCover(youtubeId, coverSrc) {
    var cover = document.createElement('div');
    cover.className = 'vgb-cover';
    cover.dataset.youtubeId = youtubeId;
    cover.setAttribute('role', 'button');
    cover.setAttribute('tabindex', '0');
    cover.setAttribute('aria-label', 'Reproduzir vídeo');
    cover.innerHTML =
      '<img class="vgb-cover__img" src="' + coverSrc + '" alt="" loading="lazy" decoding="async" width="1280" height="720">' +
      '<span class="vgb-cover__play" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M8 5.14v13.72a1 1 0 0 0 1.5.86l11.14-6.86a1 1 0 0 0 0-1.72L9.5 4.28a1 1 0 0 0-1.5.86Z" fill="currentColor" /></svg>' +
      '</span>';
    return cover;
  }

  function playCover(cover) {
    var id = cover.dataset.youtubeId;
    if (!id) return;

    var isShort = cover.classList.contains('vgb-cover--short');
    var wrapper = document.createElement('div');
    wrapper.className = isShort ? 'vgb-player vgb-player--short' : 'ratio ratio-16x9 vgb-player';
    wrapper.innerHTML =
      '<iframe src="https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0" ' +
      'frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';

    cover.replaceWith(wrapper);
  }

  function selectThumb(thumb) {
    var thumbsWrap = thumb.closest('.vgb-thumbs');
    var stageWrap = thumbsWrap.closest('.video-gallery-block').querySelector('.vgb-stage-wrap');
    var stage = stageWrap && stageWrap.querySelector('.vgb-stage');
    if (!stage) return;

    thumbsWrap.querySelectorAll('.vgb-thumb').forEach(function (t) {
      var active = t === thumb;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    stage.innerHTML = '';
    stage.appendChild(buildCover(thumb.dataset.youtubeId, thumb.dataset.coverSrc));

    thumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }

  document.addEventListener('click', function (e) {
    var cover = e.target.closest('.vgb-cover');
    if (cover) {
      playCover(cover);
      return;
    }

    var thumb = e.target.closest('.vgb-thumb');
    if (thumb) {
      selectThumb(thumb);
      return;
    }

    var nav = e.target.closest('.vgb-nav');
    if (nav) {
      var thumbsWrap = nav.closest('.video-gallery-block').querySelector('.vgb-thumbs');
      if (!thumbsWrap) return;

      var thumbs = Array.prototype.slice.call(thumbsWrap.querySelectorAll('.vgb-thumb'));
      var activeIndex = thumbs.findIndex(function (t) {
        return t.classList.contains('is-active');
      });
      if (activeIndex === -1) return;

      var dir = nav.classList.contains('vgb-nav--next') ? 1 : -1;
      var nextIndex = (activeIndex + dir + thumbs.length) % thumbs.length;
      selectThumb(thumbs[nextIndex]);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var cover = e.target.closest('.vgb-cover');
    if (!cover) return;
    e.preventDefault();
    playCover(cover);
  });
})();
